import {
  Skeleton,
  AutoComplete,
  Row,
  Col,
  Select,
  Divider,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getContactSearchResultPagination } from "../../../actions/contactAction";
import { getcontacttypecustomer } from "../../../actions/settings";
import Rendertable from "./Rendertable";

const { Option } = Select;

const ContactList = ({
  getContactSearchResultPagination,
  getcontacttypecustomer,
  List,
  reload,
  setreload,
}) => {
  const [data, setdata] = useState([]);
  const [contactType, setContactType] = useState([]);
  const [selectedContactType, setSelectedContactType] = useState("all_customer");
  const contactTypes = useRef([]); // Now stores an array of IDs
  const [loading, setloading] = useState(true);
  const keyward = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);

  // Fetch contact types once
  useEffect(() => {
    getcontacttypecustomer().then((result) => {
      setContactType(result);
      const customerTypes = result.filter((item) => item.Type === "Customer");
      const customerTypeIds = customerTypes.map((item) => item.id);
      contactTypes.current = customerTypeIds;
      setSelectedContactType("all_customer");
      setreload(true);
    });
  }, []);

  // Reload data when `reload` changes
  useEffect(() => {
    if (reload) {
      setloading(true);
      const typeParam = selectedContactType === "all_customer" ? "" : contactTypes.current.join(",");
      getContactSearchResultPagination(
        keyward.current,
        typeParam, 
        "",
        pageno.current,
        page_size.current
      ).then((result) => {
        setdata(result);
        setloading(false);
        setreload(false); // reset reload after fetching
      });
    }
  }, [reload]);

  // Handle Enter key on keyword input
  const onKeyDown = (event) => {
    if (event.keyCode === 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };

  // Render table or loader
  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <Rendertable
          List={List}
          reload={reload}
          setreload={setreload}
          pageno={pageno}
          page_size={page_size}
        />
      );
    }
  };

  return (
    <>
      <Row>
        <Col span={10}>
          <h3>Enter Customer Name</h3>
          <AutoComplete
            placeholder="input search text"
            onKeyUp={onKeyDown}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={8} offset={1}>
          <h3>Choose Priority Role</h3>
          <Select
            placeholder="Please Select Priority Role"
            style={{ width: "100%" }}
            value={selectedContactType}
            onChange={(value) => {
              if (value === "all_customer") {
                const customerTypeIds = contactType
                  .filter((type) => type.Type === "Customer")
                  .map((type) => type.id);
                contactTypes.current = customerTypeIds;
                setSelectedContactType("all_customer");
              } else {
                contactTypes.current = [value]; // wrap single selection in array
                setSelectedContactType(value);
              }
              pageno.current = 1;
              setreload(true);
            }}
          >
            <Option value="all_customer">All</Option>
            {contactType
              .filter((types) => types.Type === "Customer")
              .map((types) => (
                <Option key={types.id} value={types.id}>
                  {types.name}
                </Option>
              ))}
          </Select>
        </Col>
      </Row>
      <Divider />
      {renderdata()}
    </>
  );
};

const mapStateToProps = (state) => ({
  List: state.contacts.contactlistsearchresult,
});

export default connect(mapStateToProps, {
  getContactSearchResultPagination,
  getcontacttypecustomer,
})(ContactList);
